import * as React from 'react';
import type { VimeoProps } from '../Vimeo/Vimeo';
import { Vimeo } from '../Vimeo/Vimeo';
import type { StrictOmit } from '~/Partials/Utils/typeUtils';
import type { VimeoVideoFigureViewModel } from '~/Partials/VideoFigure/ViewModels/VimeoVideoFigureViewModel.csharp';
import { VideoFigure } from './VideoFigure';
import { resolveAspectRatio } from './videoUtils';

export type VimeoVideoFigureProps = StrictOmit<VimeoVideoFigureViewModel, 'reactComponentName'> &
    StrictOmit<VimeoProps, 'videoId' | 'title'>;

export const VimeoVideoFigure: React.FC<VimeoVideoFigureProps> = props => {
    const { caption, videoId, autoplay, width, height } = props;

    const ratio = resolveAspectRatio(width, height);

    return (
        <VideoFigure caption={caption} ratio={ratio}>
            <Vimeo videoId={videoId} title={caption} autoplay={autoplay} />
        </VideoFigure>
    );
};
